/*
 * QR Code generator library (Kotlin port)
 *
 * Based on the Java implementation by Project Nayuki (MIT License)
 * https://www.nayuki.io/page/qr-code-generator-library
 */

package io.nayuki.qrcodegen

/**
 * Appendable sequence of bits (0 or 1). Mainly used by [QrSegment].
 */
class BitBuffer(
    internal val bits: MutableList<Boolean> = mutableListOf()
) {

    val bitLength: Int
        get() = bits.size

    fun getBit(index: Int): Int {
        require(index in 0 until bitLength) { "Index out of range" }
        return if (bits[index]) 1 else 0
    }

    fun appendBits(value: Int, length: Int) {
        require(length in 0..31 && value ushr length == 0) { "Value out of range" }
        require(bitLength <= Int.MAX_VALUE - length) { "Maximum length reached" }
        for (i in length - 1 downTo 0) {
            bits.add(QrCode.getBit(value, i))
        }
    }

    fun appendData(buffer: BitBuffer) {
        require(bitLength <= Int.MAX_VALUE - buffer.bitLength) { "Maximum length reached" }
        bits.addAll(buffer.bits)
    }

    fun copy(): BitBuffer = BitBuffer(bits.toMutableList())
}
